var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"theHeader"},[_c('h1',{staticClass:"theHeader_title"},[_c('ion-icon',{staticClass:"theHeader_title_icon",attrs:{"src":require('@/assets/img/logo.svg')}}),_c('teleport-target',{attrs:{"name":"title"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }